import { connect } from "react-redux";
import { getRange, getIsLoading } from "../../reducer";
import Range from "./Range";

export default connect((state, ownProps) => ({
  range: getRange(state, ownProps.rangeLocation),
  isLoading: getIsLoading(state, ownProps.rangeLocation)
}))(Range);



// WEBPACK FOOTER //
// ./src/staff/components/Range/index.js